import React from 'react';

const Wisconsin = () => {
  return (
    <div>
      
    </div>
  );
}

export default Wisconsin;
